import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Status, GetTypeLabelList } from '../../services/apiTypes';
import {
  fetchQcTypeLabels,
  fetchTypeLabels as fetchTypeLabelsAPI,
  TypeLabelParam,
} from './api';
import { isGetTypeLabelList } from '../../_utils/typeGuardUtils';

interface TypeLabelsState {
  status: Status;
  typeLabelsMap: { [key: string]: GetTypeLabelList };
}

const initialState: TypeLabelsState = {
  status: 'idle',
  typeLabelsMap: {},
};

export const fetchTypeLabels = createAsyncThunk(
  'typeLabels/fetchTypeLabels',
  async (
    params: { query: TypeLabelParam; isInspection: boolean },
    { rejectWithValue },
  ) => {
    try {
      return params.isInspection
        ? await fetchTypeLabelsAPI(params.query)
        : await fetchQcTypeLabels(params.query);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const typeLabelsSlice = createSlice({
  name: 'typeLabels',
  initialState,
  reducers: {
    resetTypeLabels: (state) => {
      state.typeLabelsMap = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTypeLabels.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchTypeLabels.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (isGetTypeLabelList(action.payload)) {
          state.typeLabelsMap[action.meta.arg.query.categoryId] =
            action.payload;
        }
      })
      .addCase(fetchTypeLabels.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { resetTypeLabels } = typeLabelsSlice.actions;

export default typeLabelsSlice.reducer;
